import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { ContractService } from 'src/app/contract/shared/contract.service';

@Component({
  selector: 'app-add-note-dialog',
  templateUrl: './add-note-dialog.component.html',
  styleUrls: ['./add-note-dialog.component.scss']
})
export class AddNoteDialogComponent implements OnInit {
  noteForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  isEditMode: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddNoteDialogComponent>,
    private fb: FormBuilder,
    private contractService: ContractService,
    private toast: ToastrService
  ) {
    this.isEditMode = data?.note ? true : false;
    this.noteForm = this.fb.group({
      note: ['', [Validators.required]],
      comments: ['']
    });

    // If editing, populate form with existing note data
    if (this.isEditMode && data.note) {
      this.noteForm.patchValue({
        note: data.note.note || '',
        comments: data.note.comments || ''
      });
    }
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  async onSave(): Promise<void> {
    if (this.noteForm.valid) {
      this.isLoading = true;
      try {
        const formData = this.noteForm.value;
        
        if (this.isEditMode && this.data.note) {
          // Update existing note
          await this.contractService.updateNote(
            this.data.contractId,
            this.data.note.id,
            {
              note: formData.note,
              comments: formData.comments || ''
            }
          );
          this.toast.success('Note updated successfully', '');
        } else {
          // Create new note
          await this.contractService.createNote(
            this.data.contractId,
            {
              note: formData.note,
              comments: formData.comments || ''
            }
          );
          this.toast.success('Note added successfully', '');
        }
        
        this.dialogRef.close(true); // Return true to indicate success
      } catch (error) {
        console.error('Error saving note:', error);
        this.toast.error('Failed to save note. Please try again later.', '');
      } finally {
        this.isLoading = false;
      }
    }
  }

  get dialogTitle(): string {
    return this.isEditMode ? 'Edit Note' : 'Add Note';
  }
}

